import { StepProps } from 'antd'
import { ColumnsType } from 'antd/es/table'
import ProductInfoCard from './ProductInfoCard'

export const breadcrumbItem = [
  {
    title: '我的订单',
  },
  {
    title: ' 订单详情页',
  },
]
export const stepCurrents = {
  /**待发货 */
  0: 1,
  /**订单待收货 */
  5: 2,
  /**确认收货 */
  4: 3,
  /**取消订单 */
  8: 3,
}

export const titleText = {
  /**待发货 */
  0: '待发货',
  /**已发货 */
  5: '订单待收货',
  /**确认收货 */
  1: '交易完成',
  /**取消订单 */
  8: '交易取消',
}

/**步骤条 */
export const stepItems = ({ orderInfo }: { orderInfo: any }) => {
  let items: StepProps[] = [
    {
      title: '创建订单',
      description: orderInfo?.submitTime,
    },
    {
      title: '待发货',
      description: orderInfo?.submitTime,
    },
  ]

  // 发货
  const sendItem = [
    {
      title: '订单待收货',
      description: orderInfo?.status === 5 && orderInfo?.deliveryTime,
    },
    {
      title: '交易完成',
      description: orderInfo?.confirmTime,
    },
  ]

  // 取消
  const cancelItem: StepProps[] = [
    {
      title: '交易已取消',
      status: 'error',
      description: orderInfo?.updateTime,
    },
  ]

  console.log(orderInfo)

  // 取消订单
  if (orderInfo?.status === 8) {
    items.push(...cancelItem)
  } else {
    items.push(...sendItem)
  }

  return items
}

/**订单 */
export const orderColumns: ColumnsType<any> = [
  {
    title: '商品信息',
    align: 'center',
    width: 500,
    render: r => <ProductInfoCard data={r} />,
  },
  {
    title: '定价',
    dataIndex: 'price',
    align: 'center',
    render: t => (t ? t.toFixed(2) : '-'),
  },
  {
    title: '应发数量',
    dataIndex: 'shippedQuantity',
    align: 'center',
  },
  {
    title: '实发数量',
    dataIndex: 'actualQuantity',
    align: 'center',
    render: t => t || '-',
  },
  {
    title: '应付额度',
    dataIndex: 'shouldPay',
    align: 'center',
    render: t => (t ? t.toFixed(2) : '-'),
  },
  {
    title: '实付额度',
    dataIndex: 'actualPay',
    align: 'center',
    render: t => (t ? t.toFixed(2) : '-'),
  },
]
